import styled from 'styled-components'
import * as All from '../BaseStyles'

export const DropdownMenuDiv = styled(All.Div)`
    box-shadow:
    0 0px 3.8px rgba(0, 0, 0, 0.022),
    0 0px 8.3px rgba(0, 0, 0, 0.031),
    0 0px 14.9px rgba(0, 0, 0, 0.039),
    0 0px 30.5px rgba(0, 0, 0, 0.048),
    0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    border-radius: 1.2rem;
    position: absolute;
    z-index: 2;
    top: 4.8rem;
    width: 15rem;
    transform: translateX(-15rem);
    background-color: white;
    padding: 1rem;
    overflow: hidden;
    transition: height 500ms ease;
`